"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const logrocket_1 = require("../logrocket/logrocket");
const isBrowser_1 = require("../utils/isBrowser");
const types_1 = require("./types");
const uuid_1 = require("uuid");
class Logger {
    constructor(options) {
        this.JOURNEY_ID_KEY = 'x-mgm-journey-id';
        this.CORRELATION_ID_KEY = 'x-mgm-correlation-id';
        this.IDEMPOTENTCY_ID_KEY = 'Idempotency-Key';
        this.options = Object.assign({}, options);
        if ((0, isBrowser_1.isBrowser)()) {
            if (options.logRocket) {
                (0, logrocket_1.setLogRocket)(options.logRocket);
            }
            window.mgm = Object.assign(Object.assign({}, window.mgm), { logger: this });
        }
    }
    get debugMode() {
        return this.options.debugMode;
    }
    set debugMode(val) {
        this.options.debugMode = val;
    }
    getJourneyId() {
        let id;
        if ((0, isBrowser_1.isBrowser)()) {
            id = window.sessionStorage.getItem(this.JOURNEY_ID_KEY);
            if (!id) {
                id = (0, uuid_1.v4)();
                window.sessionStorage.setItem(this.JOURNEY_ID_KEY, id);
            }
        }
        else {
            id = this.inMemoryJourneyId;
            if (!id) {
                id = (0, uuid_1.v4)();
                this.inMemoryJourneyId = id;
            }
        }
        return id;
    }
    resetJourneyId() {
        if ((0, isBrowser_1.isBrowser)()) {
            window.sessionStorage.removeItem(this.JOURNEY_ID_KEY);
        }
        else {
            this.inMemoryJourneyId = undefined;
        }
        return this.getJourneyId();
    }
    getCorrelationId() {
        return (0, uuid_1.v4)();
    }
    getIdempotencyId() {
        return (0, uuid_1.v4)();
    }
    _log(logLevel, messageOrError, additionalInformation) {
        const target = this.options.debugMode || !(0, isBrowser_1.isBrowser)() ? console : (0, logrocket_1.getLogRocket)();
        if (!target) {
            return;
        }
        const information = Object.assign({ appName: this.options.appName, level: types_1.LogLevel[logLevel] }, additionalInformation);
        if (this.options.logLevel <= logLevel) {
            switch (logLevel) {
                case types_1.LogLevel.trace:
                case types_1.LogLevel.log:
                    target.log(messageOrError, Object.assign({}, information));
                    break;
                case types_1.LogLevel.debug:
                    target.debug(messageOrError, Object.assign({}, information));
                    break;
                case types_1.LogLevel.info:
                    target.info(messageOrError, Object.assign({}, information));
                    break;
                case types_1.LogLevel.warn:
                    target.warn(messageOrError, Object.assign({}, information));
                    break;
                case types_1.LogLevel.error:
                    target.error(messageOrError, Object.assign({}, information));
                    break;
            }
        }
    }
    trace(message, additionalInformation) {
        this._log(types_1.LogLevel.trace, message, additionalInformation);
    }
    debug(message, additionalInformation) {
        this._log(types_1.LogLevel.debug, message, additionalInformation);
    }
    log(message, additionalInformation) {
        this._log(types_1.LogLevel.log, message, additionalInformation);
    }
    info(message, additionalInformation) {
        this._log(types_1.LogLevel.info, message, additionalInformation);
    }
    warn(message, additionalInformation) {
        this._log(types_1.LogLevel.warn, message, additionalInformation);
    }
    error(error, additionalInformation) {
        this._log(types_1.LogLevel.warn, error, additionalInformation);
    }
    track(event, additionalInformation) {
        var _a;
        if ((0, isBrowser_1.isBrowser)()) {
            (_a = (0, logrocket_1.getLogRocket)()) === null || _a === void 0 ? void 0 : _a.track(`[${this.options.appName}] ${event}`, additionalInformation);
        }
        else {
            this.log(event, additionalInformation);
        }
    }
    captureTiming(fn, metric, additionalInformation) {
        return __awaiter(this, void 0, void 0, function* () {
            const start = new Date().getTime();
            yield fn();
            const end = new Date().getTime();
            this.track(metric, Object.assign({ duration: end - start }, additionalInformation));
        });
    }
}
exports.Logger = Logger;
